/**
 * AONSK V11.33 cart viewport repair.
 * Keeps the mobile cart inside the visual viewport when Facebook, Instagram,
 * Safari, or the on-screen keyboard changes the usable screen height.
 */
(() => {
  const IN_APP_BROWSER = /FBAN|FBAV|Instagram/i.test(navigator.userAgent || '');
  let frame = 0;
  let observer;

  const update = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;

      const viewport = window.visualViewport;
      const layoutHeight = Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0);
      const visibleHeight = viewport && viewport.height ? viewport.height : layoutHeight;
      const offsetTop = viewport && Number.isFinite(viewport.offsetTop) ? viewport.offsetTop : 0;
      const bottomInset = Math.max(0, layoutHeight - visibleHeight - offsetTop);

      drawer.style.setProperty('--aonsk-cart-vv-height', `${Math.round(visibleHeight)}px`);
      drawer.style.setProperty('--aonsk-cart-vv-bottom', `${Math.round(bottomInset)}px`);
      drawer.dataset.aonskInAppBrowser = IN_APP_BROWSER ? 'true' : 'false';

      const cartItems = drawer.querySelector('cart-items[data-empty]');
      if (cartItems) drawer.dataset.cartEmpty = cartItems.dataset.empty;

      document.documentElement.classList.toggle('aonsk-in-app-browser', IN_APP_BROWSER);
    });
  };

  const bind = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    update();
    if (observer) observer.disconnect();
    observer = new MutationObserver(update);
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  };

  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('orientationchange', update, { passive: true });
  document.addEventListener('dispatch:cart-drawer:open', update);
  document.addEventListener('dispatch:cart-drawer:refresh', update);
  document.addEventListener('shopify:section:load', bind);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', update, { passive: true });
    window.visualViewport.addEventListener('scroll', update, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
